// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__129JD","label":"Radio_label__1SxvD","checkMark":"Radio_checkMark__271h8","disabled":"Radio_disabled__2G30R"};